import React from 'react';

import { Spinner } from '@chakra-ui/react';

import { Container } from './styles';

const Loader: React.FC = () => {
  return (
    <Container>
      <Spinner />
    </Container>
  );
};

export default Loader;
